import React, { ReactNode, useState } from 'react';

export const MenuContext = React.createContext({
  mobileOpen: false,
  handleDrawerToggle: () => {},
});

export const MenuContextProvider = ({ children }: { children: ReactNode }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <MenuContext.Provider
      value={{
        mobileOpen,
        handleDrawerToggle,
      }}
    >
      {children}
    </MenuContext.Provider>
  );
};

export default MenuContext;
